import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from 'src/app/core/services/notification.service';

@Component({
  selector: 'payment-card-view',
  templateUrl: './payment-card-view.component.html',
  styleUrls: ['./payment-card-view.component.scss'],
  standalone: false,
})
export class PaymentCardViewComponent {
  public constructor(
    private _notificationService: NotificationService,
    private _translateService: TranslateService
  ) {}

  @Input() public payments: app.models.GetPagedPaymentsModel[];
  @Input() public props: app.models.DynamicPropsDictionary;
  @Input() public navigateToDetailHandler: any;

  showClipboardNotification(e: Event) {
    e.stopPropagation();

    this._notificationService.showSuccess(
      this._translateService.instant('common.copiedToClipboard'),
      this._translateService.instant('common.success')
    );
  }
}
